import { Component, OnInit } from '@angular/core';
import { AdminlistService } from "app/services/adminlist.service";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { BaseComponent } from "app/components/base.component";
import { NotificationsService } from "angular2-notifications";
import { FirebaseService } from "../../../services/firebase.service";

@Component({
	selector: 'app-adminlist',
	templateUrl: './adminlist.component.html',
	styleUrls: ['./adminlist.component.css'],
	providers: [AdminlistService],
})
export class AdminlistComponent extends BaseComponent implements OnInit {
	admins: any;
	username:string = "";
	constructor(
		private adminlistService: AdminlistService,
		private router: Router,
		private route: ActivatedRoute,
		private notificationsService: NotificationsService,
		private firebaseService: FirebaseService,
	) {
		super();
	}

	ngOnInit() {
		this.adminlistService.getAdminslist().subscribe(admins => {
			this.admins = admins.sort(function(a,b) {return (a.fullname.toLowerCase() > b.fullname.toLowerCase()) ? 1 : ((b.fullname.toLowerCase() > a.fullname.toLowerCase()) ? -1 : 0) });
		});

		this.firebaseService.getAuth().subscribe((user) => {
			if (user)
			{
				this.username = user.email;
			}
		});
	}

	onDeleteClick(id){
		var self = this;
		if(confirm("Are you sure?")){
			this.adminlistService.deleteAdmin(id).then(function(){
				self.notificationsService.error("Deleted", "1 Admin deleted, please delete the user authentication data on Firebase console manually." );
			});
		}
	}
}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/components/adminlist/adminlist/adminlist.component.ts